import React, { useState } from "react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Compass, RefreshCw, ArrowRight, Layers, Check,Clock,
  PartyPopper,
  CheckCircle2,
  X,
  Sunset,
  Cake,
  ChevronRight,
  Gift,
} from "lucide-react";
import { Camera, Heart, ShipWheel, Music, Ship, Users, Sparkles, Anchor } from "lucide-react";
import Footer from "../Components/Footer";
import FAQSection from "../Components/FAQSection";

const packageFaq = [
  {
    question: "What is the difference between a package and a basic charter?",
    answer: "A curated package offers a more complete experience and may include route planning, food, beverages, transport, sightseeing or celebration elements, while a basic charter is usually only the boat booking."
  },
  {
    question: "What kinds of packages are available?",
    answer: "Packages may include Mandwa trips, Elephanta outings, sailing experiences, private celebration packages and full-day charter formats."
  },
  {
    question: "Can a package include premium food and beverages?",
    answer: "Yes. Depending on the package, premium food, beverages and other curated inclusions may be part of the experience."
  },
  {
    question: "Are these packages directly bookable?",
    answer: "Yes. Each package card should include a direct booking option along with a details page."
  },
  {
    question: "Who are these packages best suited for?",
    answer: "They are ideal for guests who want a more seamless, more premium and more fully planned on-water experience."
  },
  {
    question: "Can I compare multiple package types on one page?",
    answer: "Yes. This page is designed to help guests browse and compare different curated package experiences in one place."
  },
  {
    question: "Are there destination-based packages for Mandwa and Elephanta?",
    answer: "Yes. The page can include destination-led packages as well as sailing, celebration and charter-led formats."
  },
  {
    question: "How do I choose the right package?",
    answer: "Choose based on your destination, group size, duration and the type of experience you want. Indiaboats can also help recommend the right package."
  }
];


const packagesData = [
  {
    id: 0,
    tabLabel: "Mandwa Curated",
    title: "Mumbai to Mandwa Curated Day Package",
    shortDesc: "A complete coastal day experience designed for guests who want a smooth and comfortable trip from Mumbai to Mandwa, with private transfers, local travel and time to enjoy the destination before returning by speed boat.",
    image: "assets/img/alibaug_package.png",
    imageAlt: "Luxury Speedboat gliding through clear blue coastal waters of Mandwa beach",
    duration: "Full Day (Flexible)",
    capacity: "Up to 12 Guests",
    includes: [
      "Private speed boat transfer from Mumbai to Mandwa",
      "Innova for local use",
      "Up to 4 hours of local sightseeing / movement",
      "Return transfer by private speed boat"
    ],
    whyLove: "This package is ideal for guests who want the convenience of a private sea route combined with comfortable local movement once they reach Mandwa. It feels far more complete than just a transfer and is perfect for day plans, meetings, private outings or a relaxed coastal escape.",
    basePrice: "₹45,000"
  },
  {
    id: 1,
    tabLabel: "Elephanta Island",
    title: "Mumbai to Elephanta Curated Island Package",
    shortDesc: "A private Elephanta outing designed for guests who want a more comfortable and better-organised island experience, with permissions, local guidance, sightseeing time and a scenic speed boat journey from Mumbai.",
    image: "assets/img/elephanta_package.png",
    imageAlt: "Historical jetty and scenic coastal view near Elephanta island",
    duration: "5 Hours",
    capacity: "Up to 10 Guests",
    includes: [
      "Private speed boat transfer from Mumbai to Elephanta",
      "Required permissions & entry passes",
      "Expert Local guide",
      "Up to 3 hours of historic exploration",
      "Return transfer by private speed boat"
    ],
    whyLove: "This package takes the stress out of planning an Elephanta visit and turns it into a more seamless and premium island experience. It is well suited for families, visitors and private groups who want the journey and the outing to feel equally enjoyable.",
    basePrice: "₹38,000"
  },
  {
    id: 2,
    tabLabel: "Premium Yacht",
    title: "Premium Yacht Sailing Experience Package",
    shortDesc: "A 6-hour premium sailing experience for guests who want more than a simple charter. This curated package combines time on a premium yacht with food, beverages and water activities for a complete day on the sea.",
    image: "assets/img/privateYacht.png",
    imageAlt: "Spectacular luxury motor yacht deck cruising on deep ocean",
    duration: "6 Hours",
    capacity: "Up to 8 Guests",
    includes: [
      "6-hour charter on a premium yacht",
      "Gourmet Catering & Beverages",
      "Kayaking & Open-water Swimming",
      "Premium Music & Ambient sound onboard"
    ],
    whyLove: "This is ideal for guests who want a more immersive and elevated sailing day rather than just a boat ride. It is a strong choice for couples, families and small private groups looking for a premium sea experience with leisure, comfort and curated inclusions already built in.",
    basePrice: "₹75,000"
  },
  {
    id: 3,
    tabLabel: "Sunrise/Sunset Sail",
    title: "Mumbai to Mandwa Day Experience with Sunset Sail Return",
    shortDesc: "A beautifully curated day package that begins with a fast speed boat ride from Mumbai to Mandwa, gives you time for lunch and a relaxed day on shore, and ends with a scenic sunset return sail to Mumbai on a sail yacht.",
    image: "assets/img/networking4.png",
    imageAlt: "Romantic sailboat rigged against a breathtaking orange sunset skyline in Mumbai",
    duration: "12 Noon - Sunset",
    capacity: "Up to 6 Guests",
    includes: [
      "12 noon private speed boat transfer from Mumbai to Mandwa",
      "Day at leisure / luxury lunch beach spend on shore",
      "Sunset return sail on a beautiful classic sail yacht",
      "Departure from Mandwa at 5 PM",
      "Premium beverages onboard during sunset cruise"
    ],
    whyLove: "This package blends convenience with experience in a very memorable way. Guests enjoy the speed and ease of a quick transfer out, followed by the charm and beauty of a sunset sailing return. It is one of the best formats for people who want the day to feel both relaxed and special.",
    basePrice: "₹52,000"
  }
];

const bcpInitialPackagesList = [
  {
    id: 'bcp-pkg-mandwa-01',
    name: "Mumbai to Mandwa Curated Day Package",
    experienceType: "Speedboat & Coastal Sightseeing",
    route: "Gateway of India ↔ Mandwa Jetty",
    duration: "Full Day (Flexible)",
    suitability: "Families & Small Groups (Up to 12 Guests)",
    image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=1000&q=80",
    imageAlt: "Premium speed boat gliding towards Mandwa",
    keyInclusions: [
      "Private speed boat transfer",
      "Innova SUV for local sightseeing",
      "4 hours of leisure movement on shore",
      "Return private speed boat transfer"
    ],
    shortDesc: "A curated Mumbai to Mandwa coastal day package designed for guests who want a more complete and premium on-water experience, with private speed boat transfers, comfortable private local travel, and leisure time ashore.",
    price: "₹45,000",
    category: "day-cruise"
  },
  {
    id: 'bcp-pkg-elephanta-02',
    name: "Mumbai to Elephanta Curated Island Package",
    experienceType: "Heritage & Guided Exploration",
    route: "Mumbai Harbour ↔ Elephanta Caves",
    duration: "5 Hours",
    suitability: "Families & History Buffs (Up to 10 Guests)",
    image: "https://images.unsplash.com/photo-1627581531126-7e4726fe3d4d?auto=format&fit=crop&w=1000&q=80",
    imageAlt: "Scenic historic waterfront view of Elephanta Island",
    keyInclusions: [
      "Private return speed boat transfers",
      "Required island entry permissions",
      "Accredited expert local guide",
      "3 hours of historical cave exploration"
    ],
    shortDesc: "A curated Mumbai to Elephanta Caves island package designed for guests who want a more complete and premium on-water experience, with fast private transfers, pre-arranged island permissions, and an expert guided tour.",
    price: "₹38,000",
    category: "island"
  },
  {
    id: 'bcp-pkg-yacht-03',
    name: "Premium Yacht Sailing Experience Package",
    experienceType: "Luxury Leisure Charter",
    route: "Mumbai Harbour Open Sea Cruise",
    duration: "6 Hours",
    suitability: "VIP Outings & Celebrations (Up to 8 Guests)",
    image: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?auto=format&fit=crop&w=1000&q=80",
    imageAlt: "Luxury yacht cruising on dark blue waters",
    keyInclusions: [
      "6-hour charter on premium yacht",
      "Gourmet food & mocktails onboard",
      "Kayaking & open-water swimming",
      "Premium surround sound system"
    ],
    shortDesc: "A curated open-sea premium yacht sailing package designed for guests who want a more complete and premium on-water experience, with curated gourmet catering, exciting open-water activities, and state-of-the-art onboard entertainment.",
    price: "₹75,000",
    category: "luxury"
  },
  {
    id: 'bcp-pkg-sunset-04',
    name: "Mumbai to Mandwa Sunset Sail Return",
    experienceType: "Mixed Speedboat & Wind Sailing",
    route: "Mumbai → Mandwa (Speed) | Mandwa → Mumbai (Sail)",
    duration: "12:00 PM - Sunset",
    suitability: "Couples & Romantic Getaways (Up to 6 Guests)",
    image: "https://images.unsplash.com/photo-1470116945706-e6bf5d5a53ca?auto=format&fit=crop&w=1000&q=80",
    imageAlt: "Sailing yacht navigating a golden sunset",
    keyInclusions: [
      "Speed boat transfer to Mandwa",
      "Afternoon leisure beach club access",
      "Return sunset sail on a classic yacht",
      "Premium mocktails & appetizers onboard"
    ],
    shortDesc: "A curated Mumbai to Mandwa day and sunset sailing package designed for guests who want a more complete and premium on-water experience, with high-speed transfer out, seaside leisure, and an unforgettable sunset sailing journey back.",
    price: "₹52,000",
    category: "luxury"
  }
];

const Packages = () => {
  

 const benefitsList = [
  "Premium yacht celebration experiences in Mumbai",
  "Ideal for birthdays, anniversaries and milestone occasions",
  "Suitable for couples, families and private groups",
  "Beautiful sea views and memorable photo moments",
  "More exclusive than standard celebration venues",
  "Support in choosing the right yacht format",
  "Experience-led planning and smooth coordination",
];

  const outcomes = [
  {
    text: " Cake-cutting ceremony",
    description:
      "Celebrate your special occasion with a memorable cake-cutting ceremony onboard the yacht.",
    icon: <Cake size={20} />,
  },
  {
    text: "Enjoy a Private Cruise",
    description:
      "Sail through Mumbai's beautiful waters while enjoying a peaceful and exclusive yacht experience.",
    icon: <ShipWheel size={20} />,
  },
  {
    text: "Play Your Favorite Music",
    description:
      "Create the perfect celebration atmosphere with your own playlist while cruising on the sea.",
    icon: <Music size={20} />,
  },
  {
    text: "Capture Stunning Photos",
    description:
      "Take unforgettable pictures with the Arabian Sea and Mumbai skyline as your backdrop.",
    icon: <Camera size={20} />,
  },
  {
    text: "Spend Quality Time Together",
    description:
      "Enjoy meaningful moments with your partner, family, or close friends in complete privacy.",
    icon: <Heart size={20} />,
  },
  {
    text: "Plan a Surprise Celebration",
    description:
      "Make birthdays and anniversaries extra special with a thoughtfully planned surprise experience.",
    icon: <Gift size={20} />,
  },
  {
    text: "Enjoy a Beautiful Sunset",
    description:
      "Watch the sun set over the Arabian Sea and create memories you'll cherish forever.",
    icon: <Sunset size={20} />,
  },
  {
    text: "Celebrate at a Unique Venue",
    description:
      "Experience a private yacht celebration that feels far more memorable than a traditional venue.",
    icon: <PartyPopper size={20} />,
  },
];

const [activeTab, setActiveTab] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPackageForModal, setSelectedPackageForModal] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [formState, setFormState] = useState({ name: '', phone: '', date: '', guests: '2' });

  const activePkg = packagesData[activeTab];

  const openBookingModal = (pkg) => {
    setSelectedPackageForModal(pkg);
    setSubmitted(false);
    setIsModalOpen(true);
  };

  const handleFormChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const [bcpPackageData, setBcpPackageData] = useState(bcpInitialPackagesList);
  const [bcpActiveCategory, setBcpActiveCategory] = useState('all');
  const [bcpSyncing, setBcpSyncing] = useState(false);
  const [bcpLastSyncedTime, setBcpLastSyncedTime] = useState(new Date().toLocaleTimeString());
  
  // Scoped Modals and Details Panel State
  const [bcpActiveModalPackage, setBcpActiveModalPackage] = useState(null);
  const [bcpModalDisplayMode, setBcpModalDisplayMode] = useState(null); // 'details' or 'book'
  const [bcpFormSubmitted, setBcpFormSubmitted] = useState(false);
  const [bcpBookingForm, setBcpBookingForm] = useState({ bcpName: '', bcpPhone: '', bcpDate: '', bcpGuests: '2' });

  const triggerBcpSync = () => {
    setBcpSyncing(true);
    setTimeout(() => {
      setBcpPackageData(bcpInitialPackagesList);
      setBcpLastSyncedTime(new Date().toLocaleTimeString());
      setBcpSyncing(false);
    }, 850);
  };

  const bcpFilteredList = bcpActiveCategory === 'all' 
    ? bcpPackageData 
    : bcpPackageData.filter(p => p.category === bcpActiveCategory);

  const bcpOpenModalHandler = (pkg, mode) => {
    setBcpActiveModalPackage(pkg);
    setBcpModalDisplayMode(mode);
    setBcpFormSubmitted(false);
  };

  const bcpCloseModalHandler = () => {
    setBcpActiveModalPackage(null);
    setBcpModalDisplayMode(null);
  };

  const bcpFormChangeHandler = (e) => {
    setBcpBookingForm({
      ...bcpBookingForm,
      [e.target.name]: e.target.value
    });
  };

  const bcpFormSubmitHandler = (e) => {
    e.preventDefault();
    setBcpFormSubmitted(true);
  };

    const highlights = [
    "More complete than a basic charter",
    "Premium inclusions and better planning flow",
    "Easier to compare and choose",
    "Better for day trips, celebrations and hosted experiences",
    "More refined overall guest experience",
    "Stronger convenience from enquiry to booking"
  ];

  return (
    <div>
      <IndiaBoatsTopBar />
      <PremiumNavbar />

       <section className="clsm-mid-root-wrapper">
      
      <div className="clsm-mid-bg-image"></div>
      
     
      <div className="clsm-mid-bg-gradient-overlay"></div>

      <div className="clsm-mid-container">
        
        {}
        <div className="clsm-mid-header">
         <div className="csrh-centered-header">
            <h1 className="csrh-hero-title">
              More Than a Charter.  <br />
              <span className="csrh-title-italic">
                A Complete Experience
              </span>
            </h1>
           
          </div>
          <div className="clsm-mid-decorative-line"></div>
        </div>

        {}
        <div className="clsm-mid-editorial-grid">
          {/* Left Column Paragraph */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
            Indiaboats curated packages are designed for guests who want a fuller and more premium experience on the water. Instead of booking only a boat, these packages bring together the full journey — whether that means a scenic island trip, a premium sailing experience or a complete end-to-end private charter day.
            </p>
          </div>

          {/* Right Column Paragraphs */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
               Depending on the package, the experience may include speed boat transfers, local transport, sightseeing, permissions, premium food and beverages, water activities, music or a complete charter format with multiple inclusions. The goal is simple: to make the day feel easier to choose, easier to book and far more enjoyable to experience.
            </p>
            <p className="clsm-mid-paragraph">
              For many guests, a curated package is the best way to move from planning to booking with more clarity and more confidence.
            </p>
          </div>
        </div>

        {}
        <div className="clsm-mid-footer">
          <div className="clsm-mid-highlight-badge">
            {/* Highly customized premium dynamic wave-and-breeze sailing wind icon */}
            <svg 
              className="clsm-mid-badge-icon" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M2 10h12a4 4 0 0 1 0 8H12" />
              <path d="M20 10a4 4 0 0 0-4-4H4" />
              <path d="M5 14h14a3 3 0 0 0 0-6H14" />
            </svg>
            <span className="clsm-mid-badge-text">
              Curated for guests who want the day to feel effortless, elevated and worth remembering.
            </span>
          </div>
        </div>

      </div>

      </section>

       <section className="ib-pkg-section">
      
      
      <div className="ib-pkg-container">
        
        {}
        <div className="ib-pkg-header">
          <span className="ib-pkg-subtitle">Exclusive Marine Outings</span>
          <h2 className="ib-pkg-main-title">Featured Curated Experiences</h2>
          <div className="ib-pkg-divider"></div>
          <p className="ib-pkg-desc-lead">
            Explore some of our most popular curated experiences, designed for guests who want a smoother, more complete and more memorable day on the water.
          </p>
        </div>

        {}
        <div className="ib-pkg-tabs-wrapper">
          {packagesData.map((pkg, idx) => (
            <button
              key={pkg.id}
              className={`ib-pkg-tab-btn ${activeTab === idx ? 'active' : ''}`}
              onClick={() => setActiveTab(idx)}
            >
              <Anchor size={15} style={{ opacity: activeTab === idx ? 1 : 0.6 }} />
              <span>{pkg.tabLabel}</span>
            </button>
          ))}
        </div>

        {}
        <div className="ib-pkg-showcase" key={activePkg.id}>
          
          {/* Left Column - Details with Image below title & description */}
          <div className="ib-pkg-details-panel">
            <div>
              <div className="ib-pkg-meta-badge">
                <span className="ib-pkg-badge-label">
                  <Sparkles size={11} /> Exclusive Experience
                </span>
                <span className="ib-pkg-badge-label">
                  <Users size={11} /> {activePkg.capacity}
                </span>
                <span className="ib-pkg-badge-label">
                  <Compass size={11} /> {activePkg.duration}
                </span>
              </div>
              
              <h3 className="ib-pkg-detail-title">{activePkg.title}</h3>
              <p className="ib-pkg-detail-desc">{activePkg.shortDesc}</p>

              {/* Curated Package High Definition Content Image */}
              <div className="ib-pkg-image-frame">
                <img 
                  src={activePkg.image} 
                  alt={activePkg.imageAlt} 
                  className="ib-pkg-display-img" 
                />
                <div className="ib-pkg-img-caption">
                  <Ship size={14} />
                  <span>{activePkg.imageAlt}</span>
                </div>
              </div>
            </div>

            <div>
              <span className="ib-pkg-section-label">Package Inclusions</span>
              <ul className="ib-pkg-includes-list">
                {activePkg.includes.map((item, index) => (
                  <li key={index} className="ib-pkg-include-item">
                    <svg className="ib-pkg-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {}
          <div className="ib-pkg-testimonial-panel">
            <div>
              <svg className="ib-pkg-quote-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
              <h4 className="ib-pkg-quote-heading">Why Guests Love It</h4>
              <p className="ib-pkg-quote-body">{activePkg.whyLove}</p>
            </div>
            
            <div className="ib-pkg-price-row">
              {/* <div className="ib-pkg-price-sub">Starting Package Price</div>
              <div className="ib-pkg-price-tag">{activePkg.basePrice}</div>
              <div className="ib-pkg-price-sub">all-inclusive curated itinerary</div> */}
              
              <button 
                className="ib-pkg-action-btn"
                onClick={() => openBookingModal(activePkg)}
              >
                Inquire & Customize
                <ChevronRight size={18} />
              </button>

              <div className="ib-pkg-brand-accent">
                Indiaboats Curated
              </div>
            </div>
          </div>

        </div>

      </div>

      {}
      {isModalOpen && (
        <div className="ib-modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="ib-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ib-modal-close" onClick={() => setIsModalOpen(false)}>
              <X size={20} />
            </button>
            
            {!submitted ? (
              <form onSubmit={handleFormSubmit}>
                <h3 className="ib-modal-title">Customize Experience</h3>
                <p className="ib-modal-subtitle">
                  Inquire for: <strong style={{color: '#113d48'}}>{selectedPackageForModal?.title}</strong>
                </p>

                <div className="ib-input-group">
                  <label className="ib-label">Your Name</label>
                  <input 
                    type="text" 
                    name="name" 
                    className="ib-input" 
                    required 
                    value={formState.name}
                    onChange={handleFormChange}
                    placeholder="E.g. Rajesh Kumar" 
                  />
                </div>

                <div className="ib-input-group">
                  <label className="ib-label">Phone / WhatsApp Number</label>
                  <input 
                    type="tel" 
                    name="phone" 
                    className="ib-input" 
                    required 
                    value={formState.phone}
                    onChange={handleFormChange}
                    placeholder="E.g. +91 98765 43210" 
                  />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                  <div className="ib-input-group">
                    <label className="ib-label">Preferred Date</label>
                    <input 
                      type="date" 
                      name="date" 
                      className="ib-input" 
                      required 
                      value={formState.date}
                      onChange={handleFormChange}
                    />
                  </div>
                  <div className="ib-input-group">
                    <label className="ib-label">Number of Guests</label>
                    <select 
                      name="guests" 
                      className="ib-input" 
                      value={formState.guests}
                      onChange={handleFormChange}
                    >
                      {[...Array(12)].map((_, i) => (
                        <option key={i+1} value={i+1}>{i+1} {i === 0 ? 'Guest' : 'Guests'}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <button type="submit" className="ib-modal-submit">
                  Send Booking Request
                </button>
              </form>
            ) : (
              <div className="ib-success-box">
                <div style={{ color: '#113d48', marginBottom: '15px' }}>
                  <CheckCircle2 size={54} style={{ margin: '0 auto' }} />
                </div>
                <h3 className="ib-modal-title" style={{ marginBottom: '10px' }}>Inquiry Received!</h3>
                <p style={{ color: '#4b656b', fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '25px' }}>
                  Thank you, <strong>{formState.name}</strong>. Our custom nautical travel advisor will review your request for <strong>{selectedPackageForModal?.tabLabel}</strong> and reach you at <strong>{formState.phone}</strong> shortly.
                </p>
                <button 
                  className="ib-modal-submit" 
                  onClick={() => setIsModalOpen(false)}
                >
                  Return to Packages
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </section>

    <section className="bcp-main-section">
      
      
      <div className="bcp-content-wrapper">
        
        {/* Isolated Section Header */}
        <div className="bcp-top-header">
          <span className="bcp-tag-line">
            <Sparkles size={14} /> Custom Yacht & Cruise Outings
          </span>
          <h2 className="bcp-hero-heading">Browse Curated Packages</h2>
          <div className="bcp-underline-accent"></div>
         
        </div>

       
        {/* Dynamic Category Filtering */}
        <div className="bcp-category-tabs-row">
          <button 
            className={`bcp-tab-pill-btn ${bcpActiveCategory === 'all' ? 'bcp-active-tab' : ''}`}
            onClick={() => setBcpActiveCategory('all')}
          >
            All Packages ({bcpPackageData.length})
          </button>
          <button 
            className={`bcp-tab-pill-btn ${bcpActiveCategory === 'day-cruise' ? 'bcp-active-tab' : ''}`}
            onClick={() => setBcpActiveCategory('day-cruise')}
          >
            Coastal Day Trips
          </button>
          <button 
            className={`bcp-tab-pill-btn ${bcpActiveCategory === 'island' ? 'bcp-active-tab' : ''}`}
            onClick={() => setBcpActiveCategory('island')}
          >
            Island Outings
          </button>
          <button 
            className={`bcp-tab-pill-btn ${bcpActiveCategory === 'luxury' ? 'bcp-active-tab' : ''}`}
            onClick={() => setBcpActiveCategory('luxury')}
          >
            Luxury Sailing
          </button>
        </div>

        {/* Grid Display */}
        <div className="bcp-cards-layout-grid">
          {bcpFilteredList.map((pkg) => (
            <article key={pkg.id} className="bcp-curated-card-wrapper">
              
              {/* Media Tagging */}
              <div className="bcp-image-media-area">
                <img src={pkg.image} alt={pkg.imageAlt} className="bcp-responsive-card-img" />
                <span className="bcp-route-overlay-tag">
                  {pkg.route}
                </span>
                <span className="bcp-ready-bookable-tag">
                  Ready Bookable
                </span>
                <div className="bcp-type-bottom-overlay">
                  {pkg.experienceType}
                </div>
              </div>

              {/* Card Main Body */}
              <div className="bcp-card-text-body">
                <h3 className="bcp-card-item-title">{pkg.name}</h3>

                {/* Meta badging details */}
                <div className="bcp-pill-badges-group">
                  <span className="bcp-meta-pill-badge">
                    <Clock size={12} /> {pkg.duration}
                  </span>
                  <span className="bcp-meta-pill-badge">
                    <Users size={12} /> {pkg.suitability}
                  </span>
                </div>

                {/* Detailed descriptions */}
                <p className="bcp-card-short-desc">{pkg.shortDesc}</p>

                {/* Essential Inclusions list */}
                <div>
                  <span className="bcp-inclusions-label-text">Key Inclusions</span>
                  <ul className="bcp-inclusions-items-list">
                    {pkg.keyInclusions.map((inc, i) => (
                      <li key={i} className="bcp-inclusion-single-item">
                        <Check className="bcp-check-indicator-icon" />
                        <span>{inc}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Footer and Interactive States */}
                <div className="bcp-card-actions-footer">
                  <div className="bcp-price-info-stack">
                    <span className="bcp-starting-price-label">Starting Price</span>
                    <span className="bcp-price-bold-value">{pkg.price}</span>
                  </div>
                  <div className="bcp-buttons-row-group">
                    <button 
                      className="bcp-view-details-action"
                      onClick={() => bcpOpenModalHandler(pkg, 'details')}
                    >
                      View Details
                    </button>
                    <button 
                      className="bcp-book-now-trigger"
                      onClick={() => bcpOpenModalHandler(pkg, 'book')}
                    >
                      Book Now
                      <ArrowRight size={14} />
                    </button>
                  </div>
                </div>

              </div>
            </article>
          ))}
        </div>

      </div>

      {}
      {bcpActiveModalPackage && (
        <div className="bcp-lightbox-modal-backdrop" onClick={bcpCloseModalHandler}>
          <div className="bcp-lightbox-modal-window" onClick={(e) => e.stopPropagation()}>
            <button className="bcp-modal-dismiss-btn" onClick={bcpCloseModalHandler}>
              <X size={20} />
            </button>

            {/* Modal Detail Display View */}
            {bcpModalDisplayMode === 'details' && (
              <div>
                <h3 className="bcp-lightbox-item-title">{bcpActiveModalPackage.name}</h3>
                <p className="bcp-lightbox-sub-title" style={{marginBottom: '15px'}}>
                  <Layers size={14} /> {bcpActiveModalPackage.experienceType}
                </p>

                <div className="bcp-lightbox-details-panel">
                  <span className="bcp-lightbox-section-heading">Experience Overview</span>
                  <p style={{fontSize: '0.92rem', color: '#4b656b', lineHeight: '1.6', margin: '0 0 15px 0'}}>
                    {bcpActiveModalPackage.shortDesc}
                  </p>
                  
                  <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px'}}>
                    <div>
                      <strong style={{fontSize: '0.8rem', color: '#113d48'}}>SUITABLE FOR:</strong>
                      <p style={{fontSize: '0.85rem', color: '#4b656b', margin: '2px 0'}}>{bcpActiveModalPackage.suitability}</p>
                    </div>
                    <div>
                      <strong style={{fontSize: '0.8rem', color: '#113d48'}}>DURATION:</strong>
                      <p style={{fontSize: '0.85rem', color: '#4b656b', margin: '2px 0'}}>{bcpActiveModalPackage.duration}</p>
                    </div>
                  </div>
                </div>

                <div className="bcp-lightbox-details-panel">
                  <span className="bcp-lightbox-section-heading">All Package Inclusions</span>
                  <ul style={{listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px'}}>
                    {bcpActiveModalPackage.keyInclusions.map((item, index) => (
                      <li key={index} style={{display: 'flex', gap: '10px', fontSize: '0.88rem', color: '#2c3e42'}}>
                        <Check style={{color: '#10b981', flexShrink: 0, width: 16, height: 16}} />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '25px'}}>
                  <div>
                    <span style={{fontSize: '0.75rem', color: '#657e84', textTransform: 'uppercase'}}>Package Price</span>
                    <p style={{fontSize: '1.5rem', fontWeight: 800, color: '#113d48', margin: 0}}>{bcpActiveModalPackage.price}</p>
                  </div>
                  <button 
                    className="bcp-book-now-trigger"
                    onClick={() => setBcpModalDisplayMode('book')}
                    style={{padding: '12px 24px'}}
                  >
                    Proceed to Booking
                  </button>
                </div>
              </div>
            )}

            {/* Modal Booking Form View */}
            {bcpModalDisplayMode === 'book' && (
              <div>
                {!bcpFormSubmitted ? (
                  <form onSubmit={bcpFormSubmitHandler}>
                    <h3 className="bcp-lightbox-item-title">Secure Live Booking</h3>
                    <p className="bcp-lightbox-sub-title">
                      Package: <strong>{bcpActiveModalPackage.name}</strong>
                    </p>

                    <div className="bcp-form-field-group">
                      <label className="bcp-form-input-label">Your Name</label>
                      <input 
                        type="text" 
                        name="bcpName" 
                        className="bcp-form-input-field" 
                        required 
                        value={bcpBookingForm.bcpName}
                        onChange={bcpFormChangeHandler}
                        placeholder="Rajesh Kumar" 
                      />
                    </div>

                    <div className="bcp-form-field-group">
                      <label className="bcp-form-input-label">Phone / WhatsApp Number</label>
                      <input 
                        type="tel" 
                        name="bcpPhone" 
                        className="bcp-form-input-field" 
                        required 
                        value={bcpBookingForm.bcpPhone}
                        onChange={bcpFormChangeHandler}
                        placeholder="+91 98765 43210" 
                      />
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                      <div className="bcp-form-field-group">
                        <label className="bcp-form-input-label">Preferred Date</label>
                        <input 
                          type="date" 
                          name="bcpDate" 
                          className="bcp-form-input-field" 
                          required 
                          value={bcpBookingForm.bcpDate}
                          onChange={bcpFormChangeHandler}
                        />
                      </div>
                      <div className="bcp-form-field-group">
                        <label className="bcp-form-input-label">Number of Guests</label>
                        <select 
                          name="bcpGuests" 
                          className="bcp-form-input-field" 
                          value={bcpBookingForm.bcpGuests}
                          onChange={bcpFormChangeHandler}
                        >
                          {[...Array(12)].map((_, i) => (
                            <option key={i+1} value={i+1}>{i+1} {i === 0 ? 'Guest' : 'Guests'}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div style={{marginTop: '10px', marginBottom: '20px', padding: '12px', borderRadius: '6px', backgroundColor: 'rgba(17,61,72,0.04)', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <span style={{fontSize: '0.8rem', color: '#4b656b'}}>Base Itinerary Price:</span>
                      <strong style={{color: '#113d48', fontSize: '1.05rem'}}>{bcpActiveModalPackage.price}</strong>
                    </div>

                    <button type="submit" className="bcp-form-submit-trigger">
                      Confirm Reservation Request
                    </button>
                  </form>
                ) : (
                  <div className="bcp-form-success-container">
                    <div style={{ color: '#10b981', marginBottom: '15px' }}>
                      <Check size={54} style={{ margin: '0 auto', border: '3px solid #10b981', borderRadius: '50%', padding: '6px' }} />
                    </div>
                    <h3 className="bcp-lightbox-item-title" style={{ marginBottom: '10px' }}>Inquiry Received!</h3>
                    <p style={{ color: '#4b656b', fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '25px' }}>
                      Thank you, <strong>{bcpBookingForm.bcpName}</strong>. A luxury coordinator will contact you shortly at <strong>{bcpBookingForm.bcpPhone}</strong> to confirm scheduling for <strong>{bcpActiveModalPackage.name}</strong>.
                    </p>
                    <button 
                      className="bcp-form-submit-trigger" 
                      onClick={bcpCloseModalHandler}
                    >
                      Back to Packages
                    </button>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      )}
    </section>

    <section className="ib-wcp-section">
     
      
      {}
      <div className="ib-wcp-container">
        
        {/* Left Editorial Narrative */}
        <div className="ib-wcp-narrative">
          <span className="ib-wcp-pre-title">Why Choose Us</span>
          <h2 className="ib-wcp-title">Why Choose a Curated Package with Indiaboats</h2>
          <div className="ib-wcp-accent-bar"></div>
          
          <p className="ib-wcp-lead-para">
            A curated package is ideal for guests who want more than a basic charter. It offers a better-planned journey, stronger convenience and a more premium overall experience. Instead of arranging every element separately, you can choose a format that already brings together the right route, the right flow and the right inclusions for the day.
          </p>
          
          <p className="ib-wcp-sub-para">
            That is what makes these packages more attractive than a simple boat booking. They feel more refined, more seamless and more complete from the very beginning.
          </p>
        </div>

        {/* Right Highlights Block */}
        <div className="ib-wcp-highlights-panel">
          <h3 className="ib-wcp-panel-headline">Key Highlights</h3>
          
          <div className="ib-wcp-grid">
            {highlights.map((item, index) => (
              <div className="ib-wcp-item" key={index}>
                <div className="ib-wcp-icon-box">
                  <svg className="ib-wcp-icon" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <span className="ib-wcp-text">{item}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>




     <FAQSection
  title="Frequently Asked Questions About Birthdays and Anniversary"
  faqData={packageFaq}
/>
     
         

        
      <Footer />
    </div>
  );
};

export default Packages;
